// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1La12","row":"styles_row__2vXzx"};